"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VolumeControl = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("rc-slider/assets/index.css");
var _MediaPlayer = require("../../constants/MediaPlayer");
var _PermissionTooltip = _interopRequireDefault(require("../Permissions/PermissionTooltip"));
var _VolumeControl = require("./VolumeControl.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var VolumeControl = exports.VolumeControl = function VolumeControl(_ref) {
  var id = _ref.id,
    _onClick = _ref.onClick,
    enableFeature = _ref.enableFeature,
    onVolumeChanged = _ref.onVolumeChanged,
    _ref$volume = _ref.volume,
    volume = _ref$volume === void 0 ? _MediaPlayer.MediaPlayer.volume : _ref$volume;
  var scale = 100;
  var _useState = (0, _react.useState)((volume * scale).toFixed(0)),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    localVolume = _useState2[0],
    setLocalVolume = _useState2[1];
  (0, _react.useEffect)(function () {
    setLocalVolume(Math.round(volume * scale));
  }, [volume]);
  var handleChange = function handleChange(value) {
    setLocalVolume(value);
    onVolumeChanged(value / scale);
  };
  var displayPermissionTooltip = function displayPermissionTooltip(targetElementId) {
    return /*#__PURE__*/_react["default"].createElement(_PermissionTooltip["default"], {
      displayTooltip: !enableFeature,
      targetElementId: targetElementId,
      requiredRole: 'Contributor, admin or show caller'
    });
  };
  var targetElementId = 'volume-control-wrapper';
  return /*#__PURE__*/_react["default"].createElement(_VolumeControl.StyledPermissionWrapper, {
    enableFeature: enableFeature
  }, /*#__PURE__*/_react["default"].createElement(_VolumeControl.VolumeControlWrapper, {
    id: targetElementId,
    onClick: function onClick(e) {
      e.stopPropagation();
      if (_onClick && enableFeature) _onClick();
    }
  }, /*#__PURE__*/_react["default"].createElement(_VolumeControl.StyledSlider, {
    id: "volumeSlider_".concat(id),
    vertical: true,
    step: 1,
    startPoint: 0,
    value: localVolume,
    defaultValue: localVolume,
    onChange: enableFeature ? handleChange : function () {}
  }), /*#__PURE__*/_react["default"].createElement(_VolumeControl.StyledOutput, {
    htmlFor: "volumeSlider_".concat(id)
  }, localVolume), displayPermissionTooltip(targetElementId)));
};
VolumeControl.propTypes = {
  live: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  // Only used for the purpose of testing
  isAudioSource: _propTypes["default"].bool,
  enableFeature: _propTypes["default"].bool,
  id: _propTypes["default"].string.isRequired,
  muted: _propTypes["default"].bool.isRequired,
  volume: _propTypes["default"].number.isRequired,
  onVolumeChanged: _propTypes["default"].func.isRequired
};